<template lang="html">

    <section class="friend-list">
        <v-content>
            <v-row class="mt-0 mb-0 pt-0 pb-0">
                <Searchbar :type="'user'" :cols="12"></Searchbar>
            </v-row>
            <GameList :headlines="friends" :voteable="false" :show-rating="true" :showUserRating="true" type="user" :url="url"></GameList>
        </v-content>
    </section>

</template>

<script lang="js">
    import GameList from "./GameList";
    import GameService from "../../services/GameService";
    import Vue from 'vue';
    import VueRouter from 'vue-router';
    import Searchbar from "./Searchbar";

    Vue.use(VueRouter);
    export default {
        name:       'friend-list',
        props:      [],
        components: {
            GameList,
            Searchbar
        },
        mounted () {
            this.getFriends();
        },
        data () {
            return {
                'friends': [],
                'url':     window.api_url + '/api/auth/friends/games',
            }
        },
        watch:      {
            user: {
                immediate: true,
                handler () {
                    this.loggedIn();
                }
            }
        },
        methods:    {
            getFriends: function () {
                GameService.getGameyByFriends()
                           .then(res => {
                               this.friends = res.data;
                               this.friends.forEach(friend => {
                                   friend.loaded = true;
                                   if (friend.games !== null && friend.games && friend.games.length > 0) {
                                       friend.games.data = friend.games;
                                   }
                               });
                                this.friends.loaded = true;
                           }).catch((err) => {
                    console.log(err);
                });
            },
            loggedIn () {
                let user = JSON.parse(localStorage.getItem('user'));
                if (!user || !user.access_token) {
                    this.$router.push('/login');
                }
            }
        },
        computed:   {}
    }


</script>

<style scoped lang="scss">
    .friend-list {

    }
</style>
